import { fetchConfig } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

function getSectionIds() {
  const ids = [];
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((component) => {
    if (component.dataset.sectionId && !ids.includes(component.dataset.sectionId)) {
      ids.push(component.dataset.sectionId);
    }
  });
  return ids;
}

function setButtonState(form, state, message = '') {
  const button = form.querySelector('.sb-cart-upsell__button');
  const status = form.querySelector('.sb-cart-upsell__status');
  if (button) {
    button.disabled = state === 'loading';
    button.textContent = state === 'loading' ? 'Adicionando' : state === 'added' ? 'Adicionado' : 'Adicionar';
  }
  if (status) status.textContent = message;
}

async function handleSubmit(event) {
  const form = event.target.closest('[data-sbeauty-cart-upsell]');
  if (!form) return;
  event.preventDefault();

  setButtonState(form, 'loading');

  const formData = new FormData(form);
  const sectionIds = getSectionIds();
  if (sectionIds.length) {
    formData.set('sections', sectionIds.join(','));
    formData.set('sections_url', window.location.pathname);
  }

  const config = fetchConfig('javascript', { body: formData });
  const response = await fetch(Theme.routes.cart_add_url, {
    ...config,
    headers: {
      ...config.headers,
      Accept: 'text/html',
    },
  });
  const payload = await response.json();

  if (!response.ok || payload.status) {
    setButtonState(form, 'idle', payload.description || payload.message || 'Não foi possível adicionar');
    return;
  }

  const variantId = String(formData.get('id') || '');
  setButtonState(form, 'added');
  form.dispatchEvent(
    new CartAddEvent(payload, 'sbeauty-cart-upsell', {
      source: 'sbeauty-cart-upsell',
      itemCount: Number(formData.get('quantity')) || 1,
      variantId,
      sections: payload.sections,
    })
  );

  window.setTimeout(() => setButtonState(form, 'idle'), 1400);
}

if (!window.__sbeautyCartUpsellBound) {
  window.__sbeautyCartUpsellBound = true;
  document.addEventListener('submit', (event) => {
    handleSubmit(event).catch((error) => {
      console.error(error);
      const form = event.target?.closest?.('[data-sbeauty-cart-upsell]');
      if (form) setButtonState(form, 'idle', 'Erro ao adicionar');
    });
  });
}
